import { Dialog, Button, DialogContent, DialogActions, DialogContentText, DialogTitle} from "@mui/material"
import { useState } from "react"
import { Form, TextInput, useNotify, useRecordContext, useRefresh, useTranslate } from "react-admin"
import { apiService } from "../../apiService"
import { AddCommentForDraftCommand, AddCommentForInvoiceCommand, AddCommentForInvoiceReminderCommand, AddCommentForReverseInvoiceCommand, DraftReadModel, InvoiceReadModel } from "../../GeneratedClients/FreeBillApi"

const AddCommentForInvoice = ({resource}: {resource: "invoices" | "drafts" | "reverseInvoices" | "invoiceReminders"}) => {

  const record: InvoiceReadModel | DraftReadModel = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const [open, setOpen] = useState<boolean>(false)
  const translate = useTranslate()

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = async(fieldValues: any) => {
    try {
      switch (resource) {
        case "invoices":
          var addCommentForInvoiceCommand: AddCommentForInvoiceCommand = {
            userId: record.userId,
            invoiceId: record.id,
            comment: fieldValues.comment
          }      
          await apiService.InvoicesApi.addCommentForInvoice({addCommentForInvoiceCommand: addCommentForInvoiceCommand, invoiceId: record.id!})      
          break;
        case "drafts":
          var addCommentForDraftCommand: AddCommentForDraftCommand = {
            userId: record.userId,
            draftId: record.id,
            comment: fieldValues.comment
          }      
          await apiService.DraftsApi.addCommentForDraft({addCommentForDraftCommand: addCommentForDraftCommand, draftId: record.id!})
          break;
        case "reverseInvoices":
          var addCommentForReverseInvoiceCommand: AddCommentForReverseInvoiceCommand = {
            userId: record.userId,
            reverseInvoiceId: record.id,
            comment: fieldValues.comment
          }      
          await apiService.ReverseInvoicesApi.addCommentForReverseInvoice({addCommentForReverseInvoiceCommand: addCommentForReverseInvoiceCommand, reverseInvoiceId: record.id!})
          break;
        case "invoiceReminders":
          var addCommentForInvoiceReminderCommand: AddCommentForInvoiceReminderCommand = {
            userId: record.userId,
            invoiceReminderId: record.id,
            comment: fieldValues.comment
          }
          await apiService.InvoiceRemindersApi.addCommentForInvoiceReminder({addCommentForInvoiceReminderCommand: addCommentForInvoiceReminderCommand, invoiceReminderId: record.id!})
          break;
        default:
          break;
      }
      handleClose()
      notify(translate("resources.invoices.notifications.commentAdded"))
      refresh()
    } catch (error) {
      notify(`${error}`, {type: "error"})
    }
  }

  if(!record) return null

  return (
    <>
      <Button 
        size='small' 
        onClick={handleOpen}
        variant="contained"
        sx={{maxWidth: "50%"}}
      >
        {translate('resources.invoices.actions.addComment')}
      </Button>
      <Dialog 
        open={open} 
        onClose={handleClose}
      >
        <DialogTitle>{translate("resources.invoices.dialogs.addComment")}</DialogTitle>
        <Form onSubmit={handleSubmit}>
          <DialogContent>
            <DialogContentText>
              <TextInput fullWidth multiline rows={5} source="comment" label={translate("resources.invoices.comment", {smart_count: 1})} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} >{translate('ra.action.cancel')}</Button>
            <Button type="submit">{translate('resources.invoices.actions.addComment')}</Button>
          </DialogActions>
        </Form>
      </Dialog>
    </>    
  )
}

export default AddCommentForInvoice